// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\nbody,\nhtml {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n.canvas {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.canvas.has-cursor-grab {\n    cursor: grab;\n}\n\n.canvas.has-cursor-grabbing {\n    cursor: grabbing;\n}\n\n.canvas.has-cursor-pointer {\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
